(() => {
  'use strict';

  const pricePattern = /£(\d[\d,]*)\.00\b/g;
  const moduTitlePattern = /^MODU([A-Za-z][A-Za-z0-9]*(?:\s+[A-Za-z0-9]+)*)$/;
  const wordmarkSelector = 'h1, h2, h3, h4, h5, h6, [role="heading"], .product-card__title, .card__heading';
  const modutrayMaterialImage = 'https://cdn.shopify.com/s/files/1/1088/8396/8339/files/IMG_20260726_093229598.jpg?v=1785244060';
  const materialPanelRatio = '4080 / 2765';

  function ensureModuBrandStyles() {
    if (document.getElementById('mf-modu-brand-styles')) return;

    const style = document.createElement('style');
    style.id = 'mf-modu-brand-styles';
    style.textContent = `
      .mf-header-wordmark,
      .mf-product-wordmark {
        display: inline-flex;
        align-items: baseline;
        color: inherit;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        white-space: normal;
      }

      .mf-header-wordmark {
        align-items: flex-start;
        white-space: nowrap;
        letter-spacing: -0.045em;
      }

      .mf-header-wordmark strong,
      .mf-product-wordmark strong {
        font: inherit;
        font-weight: 800 !important;
        letter-spacing: -0.045em;
      }

      .mf-header-wordmark__suffix,
      .mf-product-wordmark__suffix {
        font: inherit;
        font-weight: 300 !important;
        letter-spacing: -0.035em;
      }

      .mf-header-wordmark sup,
      .mf-product-wordmark sup {
        position: relative;
        top: -0.28em;
        margin-left: 0.13em;
        font-size: 0.42em;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0;
      }

      [data-mf-product-content] .mf-product-scenes.mf-material-scenes--matched {
        align-items: stretch !important;
        grid-auto-rows: 1fr !important;
      }

      [data-mf-product-content] .mf-product-scenes.mf-material-scenes--matched > .mf-product-scene {
        width: 100% !important;
        aspect-ratio: 4080 / 2765 !important;
        height: auto !important;
        min-height: 0 !important;
        overflow: hidden !important;
      }

      @media (min-width: 990px) {
        .product-information__grid:not(.product-information--media-none).product-information--media-left {
          grid-template-columns: minmax(0, 1.12fr) minmax(480px, .95fr) !important;
          gap: clamp(28px, 3vw, 48px) !important;
        }

        [data-mf-interest-block].mf-interest-block {
          display: grid !important;
          grid-template-columns: minmax(150px, .65fr) minmax(0, 1.35fr) !important;
          grid-template-rows: auto auto auto 1fr !important;
          column-gap: 20px !important;
          row-gap: 4px !important;
          align-items: start !important;
          padding: 18px 20px !important;
        }

        [data-mf-interest-block] .mf-interest-eyebrow {
          grid-column: 1 !important;
          grid-row: 1 !important;
        }

        [data-mf-interest-block] > h3 {
          grid-column: 1 !important;
          grid-row: 2 !important;
        }

        [data-mf-interest-block] > .mf-interest-copy {
          grid-column: 1 !important;
          grid-row: 3 !important;
        }

        [data-mf-interest-block] > .mf-interest-price-note {
          grid-column: 1 !important;
          grid-row: 4 !important;
          margin-bottom: 0 !important;
        }

        [data-mf-interest-block] > .mf-interest-form {
          grid-column: 2 !important;
          grid-row: 1 / span 4 !important;
          align-content: start !important;
          gap: 7px !important;
        }

        [data-mf-interest-block] .mf-interest-input {
          min-height: 44px !important;
          padding-block: 8px !important;
        }

        [data-mf-interest-block] .mf-interest-button {
          min-height: 46px !important;
        }
      }

      @media (min-width: 1200px) {
        .product-information__grid:not(.product-information--media-none).product-information--media-left {
          grid-template-columns: minmax(0, 1.2fr) minmax(540px, 1fr) !important;
        }

        [data-mf-interest-block] .mf-interest-preferences {
          grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
          column-gap: 8px !important;
          row-gap: 5px !important;
        }

        [data-mf-interest-block] .mf-interest-preferences__heading {
          grid-column: 1 / -1 !important;
          grid-row: 1 !important;
        }

        [data-mf-interest-block] .mf-interest-choice-label:nth-of-type(1) {
          grid-column: 1 !important;
          grid-row: 2 !important;
        }

        [data-mf-interest-block] .mf-interest-choice-label:nth-of-type(2) {
          grid-column: 2 !important;
          grid-row: 2 !important;
        }

        [data-mf-interest-block] .mf-interest-choice-label:nth-of-type(3) {
          grid-column: 3 !important;
          grid-row: 2 !important;
        }

        [data-mf-interest-block] .mf-interest-select:nth-of-type(1) {
          grid-column: 1 !important;
          grid-row: 3 !important;
        }

        [data-mf-interest-block] .mf-interest-select:nth-of-type(2) {
          grid-column: 2 !important;
          grid-row: 3 !important;
        }

        [data-mf-interest-block] .mf-interest-select:nth-of-type(3) {
          grid-column: 3 !important;
          grid-row: 3 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function trimWholePoundPrices(root = document) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (const node of nodes) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, textarea')) continue;
      if (pricePattern.test(node.nodeValue)) {
        pricePattern.lastIndex = 0;
        node.nodeValue = node.nodeValue.replace(pricePattern, '£$1');
      }
      pricePattern.lastIndex = 0;
    }
  }

  function buildWordmark(suffix, includeTrademark = false, header = false) {
    const wordmark = document.createElement('span');
    wordmark.className = header ? 'mf-header-wordmark' : 'mf-product-wordmark';

    const prefix = document.createElement('strong');
    prefix.textContent = 'MODU';

    const suffixElement = document.createElement('span');
    suffixElement.className = header ? 'mf-header-wordmark__suffix' : 'mf-product-wordmark__suffix';
    suffixElement.textContent = suffix;

    wordmark.append(prefix, suffixElement);

    if (includeTrademark) {
      const trademark = document.createElement('sup');
      trademark.textContent = '™';
      wordmark.appendChild(trademark);
    }

    return wordmark;
  }

  function applyHeaderWordmark(root = document) {
    const logos = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.('.header-logo')) logos.push(root);
    if (root.querySelectorAll) logos.push(...root.querySelectorAll('.header-logo'));

    for (const logo of logos) {
      if (logo.dataset.mfHeaderWordmarkApplied === 'true') continue;
      logo.dataset.mfHeaderWordmarkApplied = 'true';
      logo.setAttribute('aria-label', 'MODUflow trademark');
      logo.replaceChildren(buildWordmark('flow', true, true));
    }
  }

  function applyModuTitleStyling(root = document) {
    const candidates = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.(wordmarkSelector)) candidates.push(root);
    if (root.querySelectorAll) candidates.push(...root.querySelectorAll(wordmarkSelector));

    for (const element of candidates) {
      if (element.closest('.mf-header-wordmark, .mf-wordmark, .mf-product-wordmark')) continue;
      if (element.querySelector('a, button, input, select, textarea')) continue;

      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const match = text.match(moduTitlePattern);
      if (!match || text.length > 48) continue;
      if (element.dataset.mfWordmarkSource === text) continue;

      const suffix = match[1];
      const includeTrademark = suffix.toLowerCase() === 'flow';
      element.dataset.mfWordmarkSource = text;
      element.setAttribute('aria-label', includeTrademark ? `${text} trademark` : text);
      element.replaceChildren(buildWordmark(suffix, includeTrademark, false));
    }
  }

  function applyModutrayMaterialPhoto() {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!path.endsWith('/products/modutray-100')) return;

    const scene = document.querySelector('[data-mf-product-content] .mf-product-scene--detail');
    if (!scene) return;

    const scenes = scene.closest('.mf-product-scenes');
    const workspaceScene = scenes?.querySelector('.mf-product-scene:not(.mf-product-scene--detail)');

    scenes?.classList.add('mf-material-scenes--matched');
    scenes?.style.setProperty('align-items', 'stretch', 'important');
    scenes?.style.setProperty('grid-auto-rows', '1fr', 'important');

    for (const panel of [workspaceScene, scene]) {
      if (!panel) continue;
      panel.style.setProperty('width', '100%', 'important');
      panel.style.setProperty('aspect-ratio', materialPanelRatio, 'important');
      panel.style.setProperty('height', 'auto', 'important');
      panel.style.setProperty('min-height', '0', 'important');
      panel.style.setProperty('overflow', 'hidden', 'important');
    }

    scene.classList.add('mf-has-material-photo');
    scene.style.setProperty('padding', '0', 'important');
    scene.style.setProperty('background-color', '#e7ded0', 'important');
    scene.style.setProperty('background-image', `url("${modutrayMaterialImage}")`, 'important');
    scene.style.setProperty('background-repeat', 'no-repeat', 'important');
    scene.style.setProperty('background-position', 'center center', 'important');
    scene.style.setProperty('background-size', 'cover', 'important');
    scene.style.setProperty('background-clip', 'padding-box', 'important');
    scene.setAttribute('role', 'img');
    scene.setAttribute('aria-label', 'MODUtray 100 cases and removable wool felt inlay finishes');

    if (!scene.dataset.mfMaterialPhotoApplied) {
      scene.replaceChildren();
      scene.dataset.mfMaterialPhotoApplied = 'true';
    }
  }

  function applyProductLayoutFixes(root = document) {
    const contents = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.('[data-mf-product-content]')) contents.push(root);
    if (root.querySelectorAll) contents.push(...root.querySelectorAll('[data-mf-product-content]'));

    for (const content of contents) {
      const overview = content.querySelector('.mf-product-overview');
      const scenes = content.querySelector('.mf-product-scenes');
      const featureGrid = content.querySelector('.mf-feature-grid');
      const copy = content.querySelector('.mf-product-copy');
      if (!overview || !scenes || !featureGrid || !copy) continue;

      if (scenes.parentElement !== overview || overview.firstElementChild !== scenes) {
        overview.insertBefore(scenes, overview.firstElementChild);
      }

      if (featureGrid.parentElement !== overview || scenes.nextElementSibling !== featureGrid) {
        scenes.insertAdjacentElement('afterend', featureGrid);
      }

      if (copy.parentElement !== overview || featureGrid.nextElementSibling !== copy) {
        featureGrid.insertAdjacentElement('afterend', copy);
      }

      const mobile = window.matchMedia('(max-width: 680px)').matches;
      const spacing = mobile ? '14px' : '18px';
      scenes.style.setProperty('margin-top', '0', 'important');
      scenes.style.setProperty('margin-bottom', spacing, 'important');
      featureGrid.style.setProperty('margin-top', '0', 'important');
      featureGrid.style.setProperty('margin-bottom', spacing, 'important');
      copy.style.setProperty('margin-top', '0', 'important');
    }
  }

  function applyAll(root = document) {
    ensureModuBrandStyles();
    trimWholePoundPrices(root);
    applyHeaderWordmark(root);
    applyModuTitleStyling(root);
    applyProductLayoutFixes(root);
    applyModutrayMaterialPhoto();
  }

  function initialise() {
    applyAll();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          const value = mutation.target.nodeValue || '';
          if (value.includes('£') && value.includes('.00')) {
            mutation.target.nodeValue = value.replace(pricePattern, '£$1');
            pricePattern.lastIndex = 0;
          }
          const parent = mutation.target.parentElement;
          if (parent) applyModuTitleStyling(parent);
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            const value = node.nodeValue || '';
            if (value.includes('£') && value.includes('.00')) {
              node.nodeValue = value.replace(pricePattern, '£$1');
              pricePattern.lastIndex = 0;
            }
            if (node.parentElement) applyModuTitleStyling(node.parentElement);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            applyHeaderWordmark(node);
            applyModuTitleStyling(node);
            applyProductLayoutFixes(node);
            trimWholePoundPrices(node);
          }
        }
      }

      applyProductLayoutFixes();
      applyModutrayMaterialPhoto();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    [250, 750, 1500].forEach((delay) => window.setTimeout(() => applyAll(), delay));
    document.addEventListener('shopify:section:load', () => applyAll());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();